import { UnitWorkloadDetails } from '#server/models';
import { NavigationItem } from '../UnitWorkloadDetailsView/NavigationItem';

interface UnitWorkloadNavigationProps {
  unitWorkloadDetails: UnitWorkloadDetails;
}
export const UnitWorkloadNavigation = ({ unitWorkloadDetails }: UnitWorkloadNavigationProps) => {
  const unitWorkloadId = unitWorkloadDetails.id;
  return (
    <div className="flex w-screen items-center gap-8 bg-primary-black-90 px-5 py-5 text-sm text-secondary-grey-05">
      <NavigationItem
        unitWorkloadId={unitWorkloadId}
        linkTo={`/unit-workloads/${unitWorkloadId}`}
        navigationLabel="Unit details"
      ></NavigationItem>
      <NavigationItem
        unitWorkloadId={unitWorkloadId}
        linkTo={`/unit-workloads/${unitWorkloadId}/teaching-delivery`}
        navigationLabel="Teaching delivery (TD)"
      ></NavigationItem>
      <NavigationItem
        unitWorkloadId={unitWorkloadId}
        linkTo={`/unit-workloads/${unitWorkloadId}/teaching-related-duties`}
        navigationLabel="Teaching related duties (TRD)"
      ></NavigationItem>
    </div>
  );
};
